/**
 * Integration d'Axeptio avec Shopify pour la gestion des cookies et le consentement Google Consent Mode.
 * Ce script configure les paramètres Axeptio et initialise le SDK sur les pages Shopify.
 * Ajouté par KGA le 21/02/2024 suivant les recommandations d'intégration disponibles sur :
 * https://support.axeptio.eu/hc/fr/articles/17628559386641-Integration-Axeptio-Shopify
 */

window.axeptioSettings = {
  clientId: "65eee2f6a06fb0e52c03728c",
  cookiesVersion: "yesforlov-fr-EU",
  googleConsentMode: {
    default: {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      wait_for_update: 500
    }
  }
};
 
(function(d, s) {
  var t = d.getElementsByTagName(s)[0], e = d.createElement(s);
  e.async = true; e.src = "//static.axept.io/sdk.js";
  t.parentNode.insertBefore(e, t);
})(document, "script");

window.vendors_shopify = [{
  name: "shopify_preferences",
  title: "Préférences",
  shortDescription: "Cookies qui mémorisent vos préférences, comme le pays ou la langue, pour personnaliser vos visites sur notre site web",
  policyUrl: "https://www.shopify.com/legal/terms",
  domain: "shopify.com",
}, {
  name: "shopify_analytics",
  title: "Analytique",
  shortDescription: "Cookies pour comprendre comment vous interagissez avec notre site",
  policyUrl: "https://www.shopify.com/legal/terms",
  domain: "shopify.com",
}, {
  name: "shopify_marketing",
  title: "Marketing",
  shortDescription: "Cookies pour fournir des publicités et des communications marketing basées sur vos intérêts",
  policyUrl: "https://www.shopify.com/legal/terms",
  domain: "shopify.com",
}, {
  name: "shopify_sale_of_data",
  title: "Vente de données",
  shortDescription: "Opter pour / contre le partage / vente de données",
  policyUrl: "https://www.shopify.com/legal/terms",
  domain: "shopify.com",
}];

(_axcb = window._axcb || []).push(function(sdk) {
  sdk.on("ready", function() {
      if (!sdk.cookiesConfig) {
          return;
      }

      // Construction de l'étape Shopify dans le widget de cookies
      sdk.cookiesConfig.steps.splice(1, 0, {
          hasVendors: true,
          image: "cookie-bienvenue",
          layout: "category",
          message: "Shopify utilise plusieurs services et plugins, nous pouvons les contrôler via leur API de confidentialité",
          name: "welcome",
          onlyOnce: true,
          title: "Cookies Shopify",
          subTitle: "Shopify utilise plusieurs services, cela vous convient-il ?",
          vendors: window.vendors_shopify,
      });

      // API de consentement Shopify
      window.Shopify.loadFeatures([{
          name: "consent-tracking-api",
          version: "0.1",
      }]);
  });

  // Mise à jour de l'API de consentement Shopify
  sdk.on("consent:saved", function(payload) {
      const choices = payload.consent.preferences.vendors;
      window.Shopify.customerPrivacy.setTrackingConsent({
          preferences: choices.shopify_preferences,
          analytics: choices.shopify_analytics,
          marketing: choices.shopify_marketing,
          sale_of_data: choices.shopify_sale_of_data,
      }, () => {});
  });
});
